import { _t } from "core/language";
import VideoListItem from "core/components/VideoListItem";
import { getYouTubeThumbnail } from "core/utils/helper";
import AiChefPageWrapper from "./../components/AiChefPageWrapper";
import AiRecipeDetail from "./../components/RecipeDetail";
import { useAiChef } from "./../hooks/aiChef";
import { useSelectRow } from "core/hooks/useSelectRow";
import { AiChefTypeEnum } from './../store/types';
import { useCustomNavigate } from 'core/hooks/useCustomNavigate';
import { useRef, useEffect } from 'react'
// import { RouterName } from "core/router";
import Section from "core/components/Section";

const ImageRecipesPage = () => {
  const navigate = useCustomNavigate()
  const { dataAnalytics, params, detail, lastPage } = useAiChef(AiChefTypeEnum.meal);
  const listRef = useRef<any>(null);

  const { data, title } = dataAnalytics
  const listItem = data?.meal || [];
  const [ rowSelected, onSelectRow ] = useSelectRow(listItem, 'id', {
    isSingle: true,
  })

  useEffect(() => {
    if (listItem.length > 0) {
      if (detail?.data?.id) {
        if (listItem.map((item: any) => item.id).includes(detail?.data?.id)) {
          return onSelectRow(detail?.data)
        }
      }
      if (!rowSelected.length) {
        return onSelectRow(listItem[0])
      }
    }
  }, [listItem, detail?.data?.id])

  // Scroll function to bring the clicked item to the center of the list horizontally
  const scrollToCenter = () => {
    if (listRef.current) {
      const index = listItem.findIndex((item: any) => item.id === rowSelected[0]?.id); // Get the index of the clicked item
      const item = listRef.current?.children[index]; // Get the clicked item
      const container = listRef.current; // Get the container

      if (item && container) {
        const itemWidth = item.offsetWidth; // Width of the item
        const containerWidth = container.clientWidth; // Width of the container

        // Calculate the scroll position to center the item horizontally
        const offset = item.offsetLeft - (containerWidth / 2) + (itemWidth / 2);

        container.scrollTo({
          left: offset, // Scroll horizontally to the calculated position
          behavior: 'smooth', // Smooth scrolling
        });
      }
    }
  };

  useEffect(() => {
    scrollToCenter();
  }, [rowSelected]);

  const handleGoBack = () => {
    navigate(lastPage)
  }

  return (
    <AiChefPageWrapper url={params.url} handleGoBack={handleGoBack}>
      <div>
        <Section className="pt-3.5 pb-[10px]">
          <label className="px-4 block mb-3.5 text-base font-medium">
            {_t('aiChef.recipe.analysis_results')}
          </label>
          {title ? <label className="px-4 block mb-3.5 text-[14px] font-medium">
            {title}
          </label> : null}
          <div className="flex overflow-x-auto no-scrollbar px-4 gap-2.5" ref={listRef}>
            {listItem?.map((item: any, key: number) => (
              <VideoListItem
                key={key}
                handleClick={onSelectRow}
                dataItem={item}
                name={item.name}
                image={getYouTubeThumbnail(item.video_id)}
                type={2}
                className={`w-[140px]`}
                active={rowSelected[0]?.id === item.id}
              />
            ))}
          </div>
        </Section>
        {listItem?.length && rowSelected[0]?.id
          && <AiRecipeDetail id={rowSelected[0]?.id} />
        }
      </div>
    </AiChefPageWrapper>
  );
};

export default ImageRecipesPage;
